// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/three-blind-mice.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const threeBlindMice: Score = {
  slug: "three-blind-mice",
  n: 18,
  title: "Three Blind Mice",
  composer: "Anonymous (traditional)",
  rights: "public-domain",
  publicSafe: true,
  key: "G",
  fifths: 1,
  time: [3, 4],
  tempo: 120,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 36,
  barQuarters: 3.0,
  lowest: 54,
  highest: 79,
  hasLyrics: true,
  jasonNote: "I'm sure you've heard this popular rhyme. Play it with it's characteristic Waltz sound and feel the rhythm.",
  teaches: ["waltz feel", "left-hand chords on beats 2 and 3", "the longest piece in the book"],
  art: "/sight-reading/art/three-blind-mice.jpg",
  artRights: "stock",
  background: "/sight-reading/bg/three-blind-mice.jpg",
  notes: [
    {
  bar: 1,
  hand: "rh",
  start: 0.0,
  dur: 3.0,
  midi: 71,
  pitch: "B4",
  d: "half",
  dot: true,
  lyric: "Three"
},
    { bar: 1, hand: "lh", start: 0.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 1, hand: "lh", start: 1.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 1, hand: "lh", start: 1.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 1, hand: "lh", start: 2.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 1, hand: "lh", start: 2.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 2,
  hand: "rh",
  start: 3.0,
  dur: 3.0,
  midi: 69,
  pitch: "A4",
  d: "half",
  dot: true,
  lyric: "Blind"
},
    { bar: 2, hand: "lh", start: 3.0, dur: 1.0, midi: 54, pitch: "F#3", d: "quarter" },
    { bar: 2, hand: "lh", start: 4.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 2, hand: "lh", start: 4.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 2, hand: "lh", start: 5.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 2, hand: "lh", start: 5.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 3,
  hand: "rh",
  start: 6.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "start",
  lyric: "Mice"
},
    { bar: 3, hand: "lh", start: 6.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 3, hand: "lh", start: 7.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 3, hand: "lh", start: 7.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 3, hand: "lh", start: 8.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 3, hand: "lh", start: 8.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 4,
  hand: "rh",
  start: 9.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "stop"
},
    { bar: 4, hand: "lh", start: 9.0, dur: 2.0, midi: 55, pitch: "G3", d: "half" },
    { bar: 4, hand: "lh", start: 9.0, dur: 2.0, midi: 59, pitch: "B3", d: "half", chord: true },
    { bar: 4, hand: "lh", start: 9.0, dur: 2.0, midi: 62, pitch: "D4", d: "half", chord: true },
    { bar: 4, hand: "lh", start: 11.0, dur: 1.0, rest: true, d: "quarter" },
    {
  bar: 5,
  hand: "rh",
  start: 12.0,
  dur: 3.0,
  midi: 71,
  pitch: "B4",
  d: "half",
  dot: true,
  lyric: "Three"
},
    { bar: 5, hand: "lh", start: 12.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 5, hand: "lh", start: 13.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 5, hand: "lh", start: 13.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 5, hand: "lh", start: 14.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 5, hand: "lh", start: 14.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 6, hand: "rh", start: 15.0, dur: 2.0, midi: 69, pitch: "A4", d: "half", lyric: "Blind" },
    { bar: 6, hand: "lh", start: 15.0, dur: 1.0, midi: 54, pitch: "F#3", d: "quarter" },
    { bar: 6, hand: "lh", start: 16.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 6, hand: "lh", start: 16.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 6, hand: "rh", start: 17.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 6, hand: "lh", start: 17.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 6, hand: "lh", start: 17.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 7,
  hand: "rh",
  start: 18.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "start",
  lyric: "Mice"
},
    { bar: 7, hand: "lh", start: 18.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 7, hand: "lh", start: 19.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 7, hand: "lh", start: 19.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 7, hand: "lh", start: 20.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 7, hand: "lh", start: 20.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 8,
  hand: "rh",
  start: 21.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "stop"
},
    { bar: 8, hand: "lh", start: 21.0, dur: 2.0, midi: 55, pitch: "G3", d: "half" },
    { bar: 8, hand: "lh", start: 21.0, dur: 2.0, midi: 59, pitch: "B3", d: "half", chord: true },
    { bar: 8, hand: "lh", start: 21.0, dur: 2.0, midi: 62, pitch: "D4", d: "half", chord: true },
    { bar: 8, hand: "lh", start: 23.0, dur: 1.0, rest: true, d: "quarter" },
    {
  bar: 9,
  hand: "rh",
  start: 24.0,
  dur: 3.0,
  midi: 71,
  pitch: "B4",
  d: "half",
  dot: true,
  lyric: "See"
},
    {
  bar: 9,
  hand: "rh",
  start: 24.0,
  dur: 3.0,
  midi: 74,
  pitch: "D5",
  d: "half",
  dot: true,
  chord: true
},
    { bar: 9, hand: "lh", start: 24.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 9, hand: "lh", start: 25.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 9, hand: "lh", start: 25.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 9, hand: "lh", start: 26.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 9, hand: "lh", start: 26.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 10, hand: "rh", start: 27.0, dur: 2.0, midi: 69, pitch: "A4", d: "half", lyric: "How" },
    { bar: 10, hand: "rh", start: 27.0, dur: 2.0, midi: 72, pitch: "C5", d: "half", chord: true },
    { bar: 10, hand: "lh", start: 27.0, dur: 1.0, midi: 54, pitch: "F#3", d: "quarter" },
    { bar: 10, hand: "lh", start: 28.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 10, hand: "lh", start: 28.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 10, hand: "rh", start: 29.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 10, hand: "rh", start: 29.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", chord: true },
    { bar: 10, hand: "lh", start: 29.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 10, hand: "lh", start: 29.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 11,
  hand: "rh",
  start: 30.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "start",
  lyric: "They Run"
},
    {
  bar: 11,
  hand: "rh",
  start: 30.0,
  dur: 3.0,
  midi: 71,
  pitch: "B4",
  d: "half",
  dot: true,
  chord: true,
  tie: "start"
},
    { bar: 11, hand: "lh", start: 30.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 11, hand: "lh", start: 31.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 11, hand: "lh", start: 31.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 11, hand: "lh", start: 32.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 11, hand: "lh", start: 32.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 12,
  hand: "rh",
  start: 33.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "stop"
},
    {
  bar: 12,
  hand: "rh",
  start: 33.0,
  dur: 3.0,
  midi: 71,
  pitch: "B4",
  d: "half",
  dot: true,
  chord: true,
  tie: "stop"
},
    { bar: 12, hand: "lh", start: 33.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 12, hand: "lh", start: 34.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 12, hand: "lh", start: 34.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 12, hand: "lh", start: 35.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 12, hand: "lh", start: 35.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 13,
  hand: "rh",
  start: 36.0,
  dur: 3.0,
  midi: 71,
  pitch: "B4",
  d: "half",
  dot: true,
  lyric: "See"
},
    {
  bar: 13,
  hand: "rh",
  start: 36.0,
  dur: 3.0,
  midi: 74,
  pitch: "D5",
  d: "half",
  dot: true,
  chord: true
},
    { bar: 13, hand: "lh", start: 36.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 13, hand: "lh", start: 37.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 13, hand: "lh", start: 37.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 13, hand: "lh", start: 38.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 13, hand: "lh", start: 38.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 14, hand: "rh", start: 39.0, dur: 2.0, midi: 69, pitch: "A4", d: "half", lyric: "How" },
    { bar: 14, hand: "rh", start: 39.0, dur: 2.0, midi: 72, pitch: "C5", d: "half", chord: true },
    { bar: 14, hand: "lh", start: 39.0, dur: 1.0, midi: 54, pitch: "F#3", d: "quarter" },
    { bar: 14, hand: "lh", start: 40.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 14, hand: "lh", start: 40.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 14,
  hand: "rh",
  start: 41.0,
  dur: 1.0,
  midi: 69,
  pitch: "A4",
  d: "quarter",
  lyric: "They"
},
    { bar: 14, hand: "rh", start: 41.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", chord: true },
    { bar: 14, hand: "lh", start: 41.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 14, hand: "lh", start: 41.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 15,
  hand: "rh",
  start: 42.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "start",
  lyric: "Run"
},
    {
  bar: 15,
  hand: "rh",
  start: 42.0,
  dur: 3.0,
  midi: 71,
  pitch: "B4",
  d: "half",
  dot: true,
  chord: true,
  tie: "start"
},
    { bar: 15, hand: "lh", start: 42.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 15, hand: "lh", start: 43.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 15, hand: "lh", start: 43.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 15, hand: "lh", start: 44.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 15, hand: "lh", start: 44.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 16, hand: "rh", start: 45.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", tie: "stop" },
    {
  bar: 16,
  hand: "rh",
  start: 45.0,
  dur: 1.0,
  midi: 71,
  pitch: "B4",
  d: "quarter",
  chord: true,
  tie: "stop"
},
    { bar: 16, hand: "lh", start: 45.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 16, hand: "rh", start: 46.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 16, hand: "lh", start: 46.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 16, hand: "lh", start: 46.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 16,
  hand: "rh",
  start: 47.0,
  dur: 1.0,
  midi: 74,
  pitch: "D5",
  d: "quarter",
  lyric: "They"
},
    { bar: 16, hand: "lh", start: 47.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 16, hand: "lh", start: 47.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 17,
  hand: "rh",
  start: 48.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "All"
},
    { bar: 17, hand: "lh", start: 48.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 17, hand: "rh", start: 49.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 17, hand: "lh", start: 49.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 17, hand: "lh", start: 49.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 17,
  hand: "rh",
  start: 50.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "ran"
},
    { bar: 17, hand: "lh", start: 50.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 17, hand: "lh", start: 50.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 18,
  hand: "rh",
  start: 51.0,
  dur: 1.0,
  midi: 78,
  pitch: "F#5",
  d: "quarter",
  lyric: "af"
},
    { bar: 18, hand: "lh", start: 51.0, dur: 1.0, midi: 54, pitch: "F#3", d: "quarter" },
    {
  bar: 18,
  hand: "rh",
  start: 52.0,
  dur: 1.0,
  midi: 76,
  pitch: "E5",
  d: "quarter",
  lyric: "ter"
},
    { bar: 18, hand: "lh", start: 52.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 18, hand: "lh", start: 52.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 18,
  hand: "rh",
  start: 53.0,
  dur: 1.0,
  midi: 78,
  pitch: "F#5",
  d: "quarter",
  lyric: "the"
},
    { bar: 18, hand: "lh", start: 53.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 18, hand: "lh", start: 53.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 19, hand: "rh", start: 54.0, dur: 2.0, midi: 79, pitch: "G5", d: "half", lyric: "far" },
    { bar: 19, hand: "lh", start: 54.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 19, hand: "lh", start: 55.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 19, hand: "lh", start: 55.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 19,
  hand: "rh",
  start: 56.0,
  dur: 1.0,
  midi: 74,
  pitch: "D5",
  d: "quarter",
  lyric: "mer's"
},
    { bar: 19, hand: "lh", start: 56.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 19, hand: "lh", start: 56.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 20, hand: "rh", start: 57.0, dur: 2.0, midi: 74, pitch: "D5", d: "half", lyric: "wife" },
    { bar: 20, hand: "lh", start: 57.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 20, hand: "lh", start: 58.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 20, hand: "lh", start: 58.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 20,
  hand: "rh",
  start: 59.0,
  dur: 1.0,
  midi: 74,
  pitch: "D5",
  d: "quarter",
  lyric: "who"
},
    { bar: 20, hand: "lh", start: 59.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 20, hand: "lh", start: 59.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 21,
  hand: "rh",
  start: 60.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "cut off"
},
    { bar: 21, hand: "lh", start: 60.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 21, hand: "rh", start: 61.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 21, hand: "lh", start: 61.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 21, hand: "lh", start: 61.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 21,
  hand: "rh",
  start: 62.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "their"
},
    { bar: 21, hand: "lh", start: 62.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 21, hand: "lh", start: 62.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 22,
  hand: "rh",
  start: 63.0,
  dur: 1.0,
  midi: 78,
  pitch: "F#5",
  d: "quarter",
  lyric: "tails"
},
    { bar: 22, hand: "lh", start: 63.0, dur: 1.0, midi: 54, pitch: "F#3", d: "quarter" },
    {
  bar: 22,
  hand: "rh",
  start: 64.0,
  dur: 1.0,
  midi: 76,
  pitch: "E5",
  d: "quarter",
  lyric: "with"
},
    { bar: 22, hand: "lh", start: 64.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 22, hand: "lh", start: 64.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 22, hand: "rh", start: 65.0, dur: 1.0, midi: 78, pitch: "F#5", d: "quarter", lyric: "a" },
    { bar: 22, hand: "lh", start: 65.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 22, hand: "lh", start: 65.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 23,
  hand: "rh",
  start: 66.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "car"
},
    { bar: 23, hand: "lh", start: 66.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 23, hand: "rh", start: 67.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 23, hand: "lh", start: 67.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 23, hand: "lh", start: 67.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 23,
  hand: "rh",
  start: 68.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "ving"
},
    { bar: 23, hand: "lh", start: 68.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 23, hand: "lh", start: 68.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 24, hand: "rh", start: 69.0, dur: 2.0, midi: 74, pitch: "D5", d: "half", lyric: "knife" },
    { bar: 24, hand: "lh", start: 69.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 24, hand: "lh", start: 70.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 24, hand: "lh", start: 70.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 24,
  hand: "rh",
  start: 71.0,
  dur: 1.0,
  midi: 74,
  pitch: "D5",
  d: "quarter",
  lyric: "did"
},
    { bar: 24, hand: "lh", start: 71.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 24, hand: "lh", start: 71.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 25,
  hand: "rh",
  start: 72.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "you"
},
    { bar: 25, hand: "lh", start: 72.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 25, hand: "rh", start: 73.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 25, hand: "lh", start: 73.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 25, hand: "lh", start: 73.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 25,
  hand: "rh",
  start: 74.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "ever"
},
    { bar: 25, hand: "lh", start: 74.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 25, hand: "lh", start: 74.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 26,
  hand: "rh",
  start: 75.0,
  dur: 1.0,
  midi: 78,
  pitch: "F#5",
  d: "quarter",
  lyric: "see"
},
    { bar: 26, hand: "lh", start: 75.0, dur: 1.0, midi: 54, pitch: "F#3", d: "quarter" },
    {
  bar: 26,
  hand: "rh",
  start: 76.0,
  dur: 1.0,
  midi: 76,
  pitch: "E5",
  d: "quarter",
  lyric: "such"
},
    { bar: 26, hand: "lh", start: 76.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 26, hand: "lh", start: 76.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 26, hand: "rh", start: 77.0, dur: 1.0, midi: 78, pitch: "F#5", d: "quarter", lyric: "A" },
    { bar: 26, hand: "lh", start: 77.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 26, hand: "lh", start: 77.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 27,
  hand: "rh",
  start: 78.0,
  dur: 2.0,
  midi: 79,
  pitch: "G5",
  d: "half",
  lyric: "sight in"
},
    { bar: 27, hand: "lh", start: 78.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 27, hand: "lh", start: 79.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 27, hand: "lh", start: 79.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 27,
  hand: "rh",
  start: 80.0,
  dur: 1.0,
  midi: 74,
  pitch: "D5",
  d: "quarter",
  lyric: "your"
},
    { bar: 27, hand: "lh", start: 80.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 27, hand: "lh", start: 80.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 28, hand: "rh", start: 81.0, dur: 2.0, midi: 74, pitch: "D5", d: "half", lyric: "life" },
    { bar: 28, hand: "lh", start: 81.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 28, hand: "lh", start: 82.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 28, hand: "lh", start: 82.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 28, hand: "rh", start: 83.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 28, hand: "lh", start: 83.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 28, hand: "lh", start: 83.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 29,
  hand: "rh",
  start: 84.0,
  dur: 3.0,
  midi: 71,
  pitch: "B4",
  d: "half",
  dot: true,
  lyric: "Three"
},
    { bar: 29, hand: "lh", start: 84.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 29, hand: "lh", start: 85.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 29, hand: "lh", start: 85.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 29, hand: "lh", start: 86.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 29, hand: "lh", start: 86.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 30,
  hand: "rh",
  start: 87.0,
  dur: 3.0,
  midi: 69,
  pitch: "A4",
  d: "half",
  dot: true,
  lyric: "blind"
},
    { bar: 30, hand: "lh", start: 87.0, dur: 1.0, midi: 54, pitch: "F#3", d: "quarter" },
    { bar: 30, hand: "lh", start: 88.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 30, hand: "lh", start: 88.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 30, hand: "lh", start: 89.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 30, hand: "lh", start: 89.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 31,
  hand: "rh",
  start: 90.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "start",
  lyric: "mice"
},
    { bar: 31, hand: "lh", start: 90.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 31, hand: "lh", start: 91.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 31, hand: "lh", start: 91.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 31, hand: "lh", start: 92.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 31, hand: "lh", start: 92.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 32,
  hand: "rh",
  start: 93.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "stop"
},
    { bar: 32, hand: "lh", start: 93.0, dur: 3.0, midi: 55, pitch: "G3", d: "half", dot: true },
    {
  bar: 33,
  hand: "rh",
  start: 96.0,
  dur: 3.0,
  midi: 71,
  pitch: "B4",
  d: "half",
  dot: true,
  lyric: "three"
},
    { bar: 33, hand: "lh", start: 96.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 33, hand: "lh", start: 97.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 33, hand: "lh", start: 97.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    { bar: 33, hand: "lh", start: 98.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 33, hand: "lh", start: 98.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", chord: true },
    {
  bar: 34,
  hand: "rh",
  start: 99.0,
  dur: 3.0,
  midi: 69,
  pitch: "A4",
  d: "half",
  dot: true,
  lyric: "blind"
},
    { bar: 34, hand: "lh", start: 99.0, dur: 1.0, midi: 54, pitch: "F#3", d: "quarter" },
    { bar: 34, hand: "lh", start: 100.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    {
  bar: 34,
  hand: "lh",
  start: 100.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  chord: true
},
    { bar: 34, hand: "lh", start: 101.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    {
  bar: 34,
  hand: "lh",
  start: 101.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  chord: true
},
    {
  bar: 35,
  hand: "rh",
  start: 102.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "start",
  lyric: "mice"
},
    { bar: 35, hand: "lh", start: 102.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 35, hand: "lh", start: 103.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    {
  bar: 35,
  hand: "lh",
  start: 103.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  chord: true
},
    { bar: 35, hand: "lh", start: 104.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    {
  bar: 35,
  hand: "lh",
  start: 104.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  chord: true
},
    {
  bar: 36,
  hand: "rh",
  start: 105.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "stop"
},
    { bar: 36, hand: "lh", start: 105.0, dur: 3.0, midi: 55, pitch: "G3", d: "half", dot: true },
  ],
};
